import type { ReactNode } from "react";

type AssetSectionProps = {
  children: ReactNode;
  count: number;
  icon: ReactNode;
  subtitle: string;
  title: string;
};

export function AssetSection({
  children,
  count,
  icon,
  subtitle,
  title,
}: AssetSectionProps) {
  return (
    <div className="overflow-hidden rounded-xl border border-border-secondary">
      <div className="flex items-center justify-between gap-md border-b border-border-secondary px-lg py-md">
        <div className="flex items-center gap-md">
          <span className="flex size-9 shrink-0 items-center justify-center rounded-lg border border-border-secondary bg-bg-primary text-text-secondary">
            {icon}
          </span>
          <div className="flex flex-col">
            <span className="text-sm font-semibold text-text-primary">
              {title}
            </span>
            <span className="text-xs text-text-tertiary">{subtitle}</span>
          </div>
        </div>

        <span className="shrink-0 rounded-full border border-utility-brand-200 bg-bg-primary px-md py-xxs text-xs font-medium text-fg-brand-primary">
          {count} {count === 1 ? "item" : "items"}
        </span>
      </div>

      <div className="p-lg">{children}</div>
    </div>
  );
}
